import * as React from 'react'


export default function RadioMultiButton({ item, id, onChange, value, devices, disabled }) {

    const isDisabled = (devices.length && !devices.map(a => a.value).includes(item.value)) || disabled

    return <>
        <input
            disabled={isDisabled}
            type="radio"
            id={`switch-${id}`}
            name="switch-toggle"
            value={item.value}
            onChange={() => {
                (devices.length && devices.map(a => a.value).includes(item.value)) && onChange(item.value)
            }}
            checked={(Array.isArray(value) ? value.join().toString() : value.toString()) === item.value.toString()}
        />
        <label className={isDisabled ? 'multi-button-disabled' : ''} htmlFor={`switch-${id}`}>{item.label}</label>
    </>
}